import { apiClient } from './../client';
import { API_ENDPOINTS } from './../constant/endpoints';
import type { IApiResponse } from './../types';
import type {
    IModuleRecord,
    IOffsetPage,
    IRecordDetail,
    IRecordListParams,
    IRecordValueInput,
} from '@/features/module-builder/types';

const MB = API_ENDPOINTS.MODULE_BUILDER;

export interface IRecordWriteInput {
    values: IRecordValueInput[];
    ownerId?: string;
}

export const moduleRecordsApi = {
    list: (moduleId: string, params: IRecordListParams = {}) =>
        apiClient
            .get<IApiResponse<IOffsetPage<IModuleRecord>>>(MB.RECORDS(moduleId), {
                params: {
                    ...params,
                    filters: params.filters?.length ? JSON.stringify(params.filters) : undefined,
                },
            })
            .then((r) => r.data.data),

    getById: (moduleId: string, recordId: string) =>
        apiClient
            .get<IApiResponse<IRecordDetail>>(MB.RECORD_BY_ID(moduleId, recordId))
            .then((r) => r.data.data),

    create: (moduleId: string, input: IRecordWriteInput) =>
        apiClient
            .post<IApiResponse<{ id: string }>>(MB.RECORDS(moduleId), input)
            .then((r) => r.data.data),

    update: (moduleId: string, recordId: string, input: IRecordWriteInput) =>
        apiClient.patch(MB.RECORD_BY_ID(moduleId, recordId), input),

    remove: (moduleId: string, recordId: string) =>
        apiClient.delete(MB.RECORD_BY_ID(moduleId, recordId)),
};
